// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1A4wc","checkboxCol":"Table_checkboxCol__2OraY","emailCol":"Table_emailCol___jfdp","actionCol":"Table_actionCol__Uofru"};